/**
 * Отдельная страница регистрации клиента (Figma 1:1208).
 */

import type { PublicCatalogApi } from "../../api/catalog.api";
import { RegistrationForm } from "../wizard/RegistrationForm";

type RegistrationPageProps = {
  api: PublicCatalogApi;
  onGoWizard?: () => void;
  onGoCabinet?: () => void;
  onSessionSaved?: () => void;
};

export function RegistrationPage({
  api,
  onGoWizard,
  onGoCabinet,
  onSessionSaved,
}: RegistrationPageProps) {
  return (
    <section className="registration-page" aria-labelledby="registration-page-title">
      <header className="registration-page__header">
        <h1 id="registration-page-title" className="registration-page__title">
          Регистрация
        </h1>
        <p className="registration-page__subtitle">
          Заполните форму для получения персонального доступа к расчётам и прайс-листам
        </p>
      </header>

      <RegistrationForm
        api={api}
        projectId={null}
        layout="page"
        {...(onGoCabinet ? { onGoCabinet } : {})}
        {...(onGoWizard ? { onGoWizard } : {})}
        {...(onSessionSaved ? { onSessionSaved } : {})}
      />
    </section>
  );
}
